/**
 * NOTICE OF LICENSE
 *
 * This source file is released under commercial license by Lamia Oy.
 *
 * @copyright Copyright (c) 2020 Lamia Oy (https://lamia.fi)
 */

import Vue from 'vue';
import date from './filters/date';
import currency from './filters/currency';
import currencyValue from './filters/currencyValue';
import image from './filters/image';
import ctflimage from './filters/ctflimage';

export default function ({ store }) {
    Vue.prototype.$filters = Vue.options.filters;

    /**
     * @example {{order_created_at || date }} // 04.11.20
     */
    Vue.filter('date', function (value) {
        return date(value);
    });

    /**
     * @example {{order_created_at || dateTime }} // 04.11.20 16:20:00
     */
    Vue.filter('dateTime', function (value) {
        return date(value, true);
    });

    Vue.filter('currencyValue', function (value) {
        return currencyValue(value);
    });

    Vue.filter('currencySymbol', function (value) {
        return currency(value);
    });

    Vue.filter('image', function (value, width, height) {
        return image(value, width, height);
    });

    Vue.filter('ctflimage', function (value, width, height, quality, format) {
        return ctflimage(value, width, height, quality, format);
    });
}
